import React, { useEffect, useState, useRef } from "react";

const OrderCancelButton = ({ order, setSelectedOrder, setShowCancelDialog }) => {
    const [remainingTime, setRemainingTime] = useState(null);

    useEffect(() => {
        if (order.status === "Received") {
            const createdAt = new Date(order.createdAt).getTime();
            const expiryTime = createdAt + 15 * 60 * 1000; // 15 minutes in ms
            // const expiryTime = createdAt + 90 * 24 * 60 * 60 * 1000;

            const interval = setInterval(() => {
                const now = Date.now();
                const diff = expiryTime - now;

                if (diff > 0) {
                    setRemainingTime(diff);
                } else {
                    setRemainingTime(0);
                    clearInterval(interval);
                }
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [order]);

    const formatTime = (ms) => {
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    return (
        // <div className="border p-4 mb-4 rounded-md">
        //   <div className="flex justify-between items-center">
        // {/* <div>Order #{order.order_id}</div> */}
        <>
            {order.status === "Received" && remainingTime > 0 && (
                // {order.status === "Received" && (
                <button
                    className="bg-red-700 text-white px-3 py-2 rounded hover:bg-red-500 text-sm"
                    onClick={() => {
                        setSelectedOrder(order);
                        setShowCancelDialog(true);
                    }}
                >
                    Cancel Within ({formatTime(remainingTime)})
                </button>
            )}
        </>
        //   </div>
        // </div>
    );
};

export default OrderCancelButton;
